import React from 'react';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';


interface PlaceholderContentProps {
  label: string;
}

export const PlaceholderContent: React.FC<PlaceholderContentProps> = ({ label }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 300,
    }}
  >
    <Text variant="body-medium" color={colors.grays.neutral66}>
      {label}
    </Text>
  </div>
);
